import instance from 'api/instance';
import { IUploadFile } from './types';

export const uploadFile: IUploadFile = (file) =>
  instance.post('/public/files', file);

export const getFile = (src: string) => instance.get(`/${src}`);
